import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mark",
  "use": "mark-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"mark\"><defs><style type=\"text/css\"></style></defs><path d=\"M383.31392 511.83104c0 71.26016 57.76384 129.024 129.024 129.024s129.02912-57.76384 129.02912-129.024c0-71.25504-57.76896-129.024-129.02912-129.024s-129.024 57.76384-129.024 129.024z\" p-id=\"113591\" fill=\"#2c2c2c\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/mark.svg
// module id = Rvdz
// module chunks = 38